import { opacity } from '../../../lib/colourUtilities';
import theme from '../../../lib/theme';
import { AdProps } from './Ad';

const { corners, colors, layouts, scale, media } = theme;

export default ({
  align = 'center',
  gutter = 's',
  backgroundColor = opacity(colors['light_grey'], 70),
  sticky,
}: AdProps) => ({
  container: {
    ...layouts.column,

    position: sticky ? 'sticky' : 'static',
    top: sticky ? 0 : undefined,
    alignItems: align,
    justifyContent: 'center',
    marginLeft: `-${scale.xs}`,
    marginRight: `-${scale.xs}`,
    borderRadius: `0 !important`,
    backgroundColor: `${backgroundColor} !important`,

    '& > div': {
      padding: typeof gutter === 'string' ? `${scale[gutter]} 0` : `0 !important`,
    },

    [media.s.up]: {
      marginLeft: 0,
      marginRight: 0,
      borderRadius: corners.m,
    },
  },
});
